import React, { Children } from 'react';
import { TrendingUp, Wrench, DollarSign } from 'lucide-react';
import { motion } from 'framer-motion';
export function CaseStudies() {
  const cases = [{
    title: 'The Strategic Upgrade',
    location: 'Central Chatsworth',
    purchase: 'Classic 1980s Ranch',
    strategy: 'Advised family on high-ROI updates: modernized the kitchen, refreshed baths, and enhanced the outdoor living space.',
    result: 'Sold for top dollar in 14 days. The strategic upgrades yielded a 2.5x return on the renovation investment, maximizing family equity.',
    icon: Wrench
  }, {
    title: 'The ADU Addition',
    location: 'Near Twin Lakes Influence',
    purchase: 'Large Lot Property',
    strategy: 'Helped homeowners navigate zoning and tax implications to convert a detached structure into a fully permitted ADU.',
    result: 'Generates $2,200/mo in rental income, covering a significant portion of their primary mortgage while adding massive appraised value.',
    icon: DollarSign
  }, {
    title: 'The 1031 Legacy Move',
    location: 'North Chatsworth',
    purchase: 'Aging Rental Property',
    strategy: 'Leveraged tax angles to execute a 1031 exchange, moving equity from a high-maintenance property into a turn-key asset.',
    result: 'Protected equity and increased monthly cash flow by 30% with zero immediate capital gains tax penalty.',
    icon: TrendingUp
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 40
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-32 bg-gray-950 text-white relative overflow-hidden" data-id="element-90">
      {/* Abstract Background Elements */}
      <div className="absolute top-0 right-0 -mt-40 -mr-40 w-[600px] h-[600px] bg-brand-gold rounded-full opacity-[0.03] blur-[100px]" data-id="element-91"></div>
      <div className="absolute bottom-0 left-0 -mb-40 -ml-40 w-[600px] h-[600px] bg-brand-gold rounded-full opacity-[0.03] blur-[100px]" data-id="element-92"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-3xl mx-auto mb-20" data-id="element-94">
          <h2 className="text-sm font-bold tracking-widest text-brand-gold uppercase mb-4" data-id="element-95">
            The Receipts
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-96">
            Real Upgrades. Real Wealth.
          </h3>
          <p className="text-gray-400 text-lg leading-relaxed" data-id="element-97">
            We don't just sell houses. We help families improve their biggest
            asset, protect their equity, and plan for the next chapter. Here is
            how we execute in 91311.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-98">
          {cases.map((study, idx) => <motion.div key={idx} variants={cardVariants} whileHover={{
          y: -10
        }} className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-3xl p-10 hover:border-brand-gold/40 hover:bg-gray-900 transition-all duration-300 group shadow-2xl" data-id="element-99">
              <div className="w-14 h-14 bg-gray-950 rounded-2xl flex items-center justify-center mb-8 border border-gray-800 group-hover:border-brand-gold/50 transition-colors" data-id="element-100">
                <study.icon className="w-6 h-6 text-brand-gold" data-id="element-101" />
              </div>
              <h4 className="text-2xl font-serif text-white mb-2" data-id="element-102">
                {study.title}
              </h4>
              <p className="text-xs text-brand-gold uppercase tracking-widest font-bold mb-8" data-id="element-103">
                {study.location}
              </p>

              <div className="space-y-6" data-id="element-104">
                <div data-id="element-105">
                  <p className="text-xs text-gray-500 uppercase tracking-widest font-bold mb-2" data-id="element-106">
                    The Move
                  </p>
                  <p className="text-sm text-gray-300 leading-relaxed" data-id="element-107">
                    {study.strategy}
                  </p>
                </div>
                <div className="pt-6 border-t border-gray-800" data-id="element-108">
                  <p className="text-xs text-gray-500 uppercase tracking-widest font-bold mb-2" data-id="element-109">
                    The Result
                  </p>
                  <p className="text-sm font-medium text-white leading-relaxed" data-id="element-110">
                    {study.result}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}